import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { chevronLeftIcon } from '@progress/kendo-svg-icons';

import { PlayerContext } from '../contexts/player';
import { GameDocumentContext } from '../contexts/game-document';
import { NavigateToWorldMap } from '../utils/game-engine/player';
import { UpdatePlayerStateAsync } from '../utils/game-engine/base';
import { getContrastingTextColor, hexToRGB } from '../utils/hex-to-rgb';

const ZoneBackButton: React.FC<{
  mapType: 'openStreetMap' | 'satelliteMap' | 'illustrated' | 'googleMaps';
}> = ({ mapType }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [, setPlayer] = React.useContext(PlayerContext);

  const theme = gameDocument.theme?.colors ?? [];

  React.useEffect(() => {
    if (theme) {
      const primaryColor = theme.find((x) => x.type === 'Primary');
      const backButton = document.querySelector('.zone-back-button');

      if (backButton) {
        if (!primaryColor) {
          (backButton as HTMLElement).style.backgroundColor = 'rgb(70,152,203)';
          (backButton as HTMLElement).style.border = 'rgb(70,152,203)';
          (backButton as HTMLElement).style.color = 'white';
        }

        if (primaryColor) {
          let { color } = primaryColor;
          color = hexToRGB(color);
          const textColor = getContrastingTextColor(color);
          (backButton as HTMLElement).style.backgroundColor = color;
          (backButton as HTMLElement).style.border = color;
          (backButton as HTMLElement).style.color = textColor;
        }
      }
    }
  }, [theme]);

  return (
    <Button
      svgIcon={chevronLeftIcon}
      onClick={() =>
        setPlayer((prev) => {
          const response = NavigateToWorldMap(prev);
          return UpdatePlayerStateAsync(prev, response);
        })
      }
      className={`zone-back-button shadow mt-2 ${mapType === 'illustrated' ? 'on-illustration' : ''}`}
      size={'small'}>
      Back
    </Button>
  );
};

export default React.memo(ZoneBackButton);
